module.exports = __webpack_public_path__ + "files/97e0f837b15a23b9f10cce45dc9c0cfd.png";